export default __webpack_public_path__ + "images/78007c92ddceaba9e21b0b63826bbb74-covidresources.png";